/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import axios from "axios";
import { Badge, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import config from "../../../../config.json";
import "../../../i18n";
import { useTranslation } from "react-i18next";

const ChoiceHistory = ({
  item,
  fetchItems,
  selected = false,
  onToggleSelect,
}) => {
  const { t } = useTranslation();
  const {
    // name,
    _id,
    choiceDetails = [],
    isArchived,
  } = item;

  const restoreItem = async () => {
    try {
      await axios.put(`${config.dev}/v2/choices/restore/${_id}`).then(() => {
        swal(t("successTitle"), t("choiceIsActivated"), t("success"));
      });
      fetchItems();
    } catch (error) {
      swal(t("errorTitle"), "" + error, t("error"));
    }
  };
  const deleteChoiceForever = async () => {
    const ok = await swal({
      title: t("areYouSure") || "Are you sure?",
      text: t("deleteForeverWarning") || "This action cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });
    if (!ok) return;
    try {
      await axios.delete(`${config.dev}/v2/choices/delete/${_id}`);
      swal(t("successTitle"), t("deletedSuccessfully") || "Deleted permanently", t("success"));
      fetchItems();
    } catch (error) {
      swal(t("errorTitle"), error?.response?.data?.message || "" + error, t("error"));
    }
  };
  if (!isArchived) return null;

  return (
    <div className="col-xl-3 col-lg-4 col-md-8 col-sm-12 mx-2">
      <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-start mb-2">
            <input
              type="checkbox"
              className="form-check-input"
              checked={selected}
              onChange={(e) => onToggleSelect?.(_id, e.target.checked)}
            />
          </div>
          <div className="new-arrival-product">
            <div className="d-flex justify-content-end">
              <div className="basic-dropdown">
                <Dropdown>
                  <Dropdown.Toggle
                    as="button"
                    variant=""
                    className="btn sharp btn-primary tp-btn mt-1"
                    id="tp-btn"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <rect x="0" y="0" width="24" height="24" />
                        <circle fill="#000000" cx="12" cy="5" r="2" />
                        <circle fill="#000000" cx="12" cy="12" r="2" />
                        <circle fill="#000000" cx="12" cy="19" r="2" />
                      </g>
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as={Link} to={`/choice-details/${_id}`}>
                      <i className="fa fa-eye me-2"></i>
                      {t("details")}
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        restoreItem();
                      }}
                    >
                      <i className="fa fa-archive me-2"></i>
                      {t("restore")}{" "}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={deleteChoiceForever}>
                      <i className="fa fa-trash me-2 text-danger"></i>
                      {t("deleteForever") || "Delete forever"}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>

            <div className="new-arrival-content text-center mt-3">
              <h4>
                <Link to="#" className="text-black">
                  {choiceDetails.map((item) =>
                    item.language === "en" ? item.choiceTitle : null
                  )}
                </Link>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChoiceHistory;
